import Header from "../components/Header/Header";
import Filters from "../components/Filters/Filters";
import Content from "../components/Content/Content";

const LandingPage = () => {
    return (
        <div>
            <Header />
            <Filters />
            <Content />
        </div>
    );
}

export default LandingPage;